import { concat, last } from 'lodash';
import { auth as useAuthStore } from 'src/store/auth';
import { shouldHideTrainingContent } from 'src/utils/ProgramUtils';

export default {
  currentFolder: (state) => last(state.currentFolderPath),

  allPrograms: (state) => concat(state.programs, state.deletedPrograms),

  visiblePrograms: (state) => {
    const { currentClient, userIsAdmin } = useAuthStore();

    if (userIsAdmin || currentClient?.type !== 'staff') {
      return state.programs;
    }
    return state.programs.filter((program) => !shouldHideTrainingContent(program, currentClient, userIsAdmin));
  },
};
